import { RaRecord } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';

import { MethodsCreateForm } from './MethodsCreateForm/MethodsCreateForm';

export const MethodsCreate: React.FC = () => {
  const transform = (data: RaRecord): RaRecord => {
    return {
      ...data,
      logo: data.logo || null,
    };
  };

  return (
    <CreateGuesserPage
      listName="Методы"
      mutationOptions={{ onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButtonValidated key="save-button" label="Создать" />,
      ]}
      title="Создание метода"
      transform={transform}
    >
      <Box sx={{ width: '100%', marginTop: '22px', marginBottom: '24px' }}>
        <MethodsCreateForm />
      </Box>
    </CreateGuesserPage>
  );
};
